import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { RateQuoteRequestDetails } from '../components/rate-quote-request-details-card';
import { purchaseDetailsSelector, refiDetailsSelector } from '../selectors/rate-quote/rate-quote';

export const Details = connect(
  createSelector(purchaseDetailsSelector, refiDetailsSelector, i => i)
)(RateQuoteRequestDetails);
